<template>
<div class="home">
    <div class="d-sm-flex align-items-center justify-content-between mb-3">
        <h1 class="h3 mb-0 text-gray-800">Archive</h1>
    </div>

    <job-table-archive :statusStep="statusStep"></job-table-archive>
</div>
</template>

<script>

import JobTableArchive from "@/components/JobTableArchive";

export default {
    name: "Archive",
    components: {
        JobTableArchive
    },
    data() {
        return {
            statusStep: "Completed",
        };
    },
    computed: {

    },

    mounted() {


    },

    methods: {

    }

};
</script>
